import * as yup from 'yup';

export const DemographicsSurveySchema = yup.object().shape({
  age: yup.number().required('Age'),
  gender: yup.string().required('Gender'),
  raceEthnicHeritage: yup.string().required('Ethnicity'),
  annualHouseholdIncome: yup.string().required('Household income'),
  companySize: yup.string().required('Company size'),
  industry: yup.string().required('Industry'),
  seniority: yup.string().required('Seniority'),
  country: yup.string().required('Country'),
  state: yup.string().when('country', {
    is: (val) => val === 'us',
    then: () => yup.string().required('State'),
    otherwise: () => yup.string(),
  }),
  jobsSelected: yup.array().required('Job Role'),
});
